import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

/** App-wide footer with legal links. */
export function Footer() {
  const { t } = useLang();
  return (
    <footer className="app-footer">
      <div className="wrap app-footer-inner">
        <span>© {new Date().getFullYear()} OnboardForge</span>
        <nav style={{ display: "flex", gap: 18, flexWrap: "wrap" }}>
          <Link to="/pricing">{t("Prijzen", "Pricing")}</Link>
          <Link to="/privacy">{t("Privacy", "Privacy")}</Link>
          <Link to="/dpa">{t("Verwerkersovereenkomst", "Data processing agreement")}</Link>
        </nav>
      </div>
    </footer>
  );
}
